import {
  load, clone, updateLayerObjects, updatePage, productionFile,
  deletePage, updateDesign, updateDesignTemplate
} from '@/services/design'

export default {
  state: {
    design: null,
    invalidatedId: null, // design Id that must be reloaded
    // Track which pages have had SVG applied (using bits)
    // This facilitates requesting the production File, which is relied
    // upon by the card-tester code.
    pagesSaved: 0,
    pageNum: 0,
    // Vue reactivity likes to have properties pre-defined
    thumbnails: {0: null, 1: null},
    editorMessage: '',
    // For debugging, track the page SVG. Setting directly on design.pages is not reactive :(
    pageSvg: {0: '', 1: ''}
  },
  mutations: {
    setDesign(state, design) {
      state.design = design
      state.pagesSaved = 0;
      state.thumbnails = {0: null, 1: null};
    },
    clearDesign(state) {
      console.log('clearDesign');
      state.design = null;
      state.pagesSaved = 0;
      state.thumbnails = {0: null, 1: null};
    },
    invalidateDesign(state) {
      state.invalidatedId = state.design && state.design.id;
    },
    setPage(state, num) {
      state.pageNum = num;
    },
    setThumbnail(state, {pageNum, dataUrl}) {
      state.thumbnails[pageNum] = dataUrl;
    },
    pageSaved(state, {pageNum, svg}) {
      state.pagesSaved++;
      // Keep SVG updated so that debugTools can access it
      state.pageSvg[pageNum] = svg;
    },
    setEditorMessage(state, message) {
      state.editorMessage = message;
    },
    dropSecondPage(state) {
      // Delete second item of array; use splice so Vue notices the change
      state.design.pages.splice(1, 1);
      state.thumbnails[1] = null;
    },
    setDesignOptions(state, designOptions) {
      state.design.designOptions = designOptions;
    }
  },
  actions: {
    setDesign(context, design) {
      context.commit('setDesign', design);
    },
    async setCurrentDesignId({state, getters, commit}, id) {
      console.log('setCurrentDesignId', getters.designId, id, state.invalidatedId);
      if (getters.designId != id || state.invalidatedId == id) {
        commit('clearDesign');
      }
      if (!state.design) {
        // request the design
        var design = await load(id);
        commit('setDesign', design);
      }
    },
    invalidateDesign({commit}) {
      console.log('invalidateDesign');
      commit('invalidateDesign');
    },
    setPage(context, num) {
      context.commit('setPage', num)
    },
    setThumbnail(context, {pageNum, dataUrl}) {
      context.commit('setThumbnail', {pageNum, dataUrl});
      context.commit('updateBasketThumbnail', {designId: context.getters.designId, pageNum, dataUrl});
    },
    async updatePage({state, getters, commit}, {pageNum, svg, previewDataUrl}) {
      let pageId = state.design.pages[pageNum].id;
      if (!pageId) return console.error("No pageId, can't update page!", pageNum);
      await updatePage(pageId, svg, previewDataUrl);
      commit('pageSaved', {pageNum, svg});
      if (state.pagesSaved === getters.designPageCount) {
        let result = await productionFile(state.design.id);
      }
    },
    async updateCanvasLayer({state}, {pageNum, objects, meta}) {
      let layerId = state.design.pages[pageNum].textLayer.id;
      return updateLayerObjects(layerId, objects, meta);
    },
    async startDesignFromTemplate(context, template_design_id) {
      let newDesign = await clone(template_design_id);
      context.commit('setDesign', newDesign);
      return newDesign
    },
    async dropSecondPageFromDesign({state, commit}) {
      let pageId = state.design.pages[1].id;
      commit('dropSecondPage');
      await deletePage(pageId);
    },
    showEditorMessage(context, message) {
      this.commit('setEditorMessage', message);
    },
    setDesignOptions({getters, commit}, designOptions) {
      updateDesign(getters.designId, {designOptions});
      commit('setDesignOptions', designOptions);
    },
    async updateDesignTemplate({state, commit}, source_template) {
      // Update the given design to use the layout from new template
      let design = await updateDesignTemplate(state.design.id, {source_template});
      commit('setDesign', design);
    },
    async updateDesignTemplateClone({state, commit}, source_template) {
      // Clone the design, then update the given design to use the layout from new template.
      // This allows non-destructrive previewing. Returns the design ID; caller should update
      // URL or open new window. This means data is refetched but thats ok.
      let design = await updateDesignTemplate(state.design.id, {source_template, clone: true});
      console.log('updateDesignTemplate', design.id);
      return design.id;
    }
  },
  getters: {
    pageData: state => pageNum => state.design && state.design.pages[pageNum],
    design: state => state.design,
    designId: state => state.design && state.design.id,
    thumbnails: state => state.thumbnails,
    designPageCount: state => state.design && state.design.pages.length,
    designOrientation: state => state.design && orientation(state.design.pages[0].mediaBox),
    pageNum: state => state.pageNum,
    isTemplate: state => state.design && state.design.isTemplate,
    editorMessage: state => state.editorMessage,
    designProductId: state => state.design && state.design.product,
    missingFonts: state => (state.design && state.design.missingFonts) || [],
    validUploadTypes: (state, getters) => 'image/png,image/x-png,image/jpeg' + (getters.flags.svgUpload ? ',image/svg+xml,image/svg' : ''),
    validUploadTypeText: (state, getters) => getters.flags.svgUpload ? 'PNG, JPEG or SVG' : 'PNG or JPEG',
    designOptions: state => state.design && (state.design.designOptions || {}),
    pageSvg: state => state.pageSvg,
  }
}
function orientation([x, y, w, h]) {
  return w > h ? 'landscape' : 'portrait';
}



// WEBPACK FOOTER //
// ./src/store/design.js